import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import EditQuickNote from "./EditQuickNote";
import DeleteNote from "./DeleteNote";
import ViewNote from "./ViewNote";
import TypeNoteChip from "../Chips/TypeNoteChip";
import { useNavigate } from "react-router-dom";
import DateAndTimeChipMobile from "../Chips/DateAndTimeChipMobile";
import EditButtonMobile from "../Buttons/EditButtonMobile";
import DeleteButtoMobile from "../Buttons/DeleteButtoMobile";
import SmallClientChipMobile from "../SmallClientChipMobile";

function NotesContainerMobile(props) {
  //VARIABLES
  const styleLive = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 600,
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };


  const styleEdit2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 260,
    borderRadius: 2,
    bgcolor: "background.paper",
    /*border: "1px solid #000",*/
    boxShadow: 24,
    // p: 4,
  };

  //STATES
  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  const [shouldNavigate, setShouldNavigate] = React.useState(false);

  //FUNCTIONS
  const openEditModal = () => {
    setShowEditModal(true);
  };
  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };
  const closeEditModal = () => {
    setShowEditModal(false);
  };
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  const handleNavigate = () => {
    setShouldNavigate(true);
  };

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(`/client/${props.clientId}`, {
        state: props, // Passez l'objet client complet
      });
    }
  }, [shouldNavigate]);

  return (
    <div className="notes-wrapper">
      <Modal
        open={showEditModal}
        onClose={closeEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleEdit2}>
          <EditQuickNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeEditModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDeleteModal}>
          <DeleteNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeDeleteModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <ViewNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeViewModal}
          />
        </Box>
      </Modal>
      <div className="note-container-mobile">
        <div className="note-container-block-1-mobile">
          <div style={{ marginRight: "5px" }}>
            <TypeNoteChip noteType={props.noteType} />
          </div>
          <DateAndTimeChipMobile date={props.noteDate} />
          <DateAndTimeChipMobile date={props.noteTime} />
        </div>

        <div className="note-container-block-3-mobile">
          <div className="note-container-line-1-mobile">
            <div
              className="note-container-line1-block1-mobile centre-block"
              onClick={handleNavigate}
              style={{ cursor: "pointer" }}
            >
              <SmallClientChipMobile
                firstName={props.clientFirstName}
                lastName={props.clientLastName}
                avatar="1"
                clientPic={props.clientPic}
              />
            </div>
            <div className="note-container-line1-block1bis-mobile left-block">
              <div className="title-cell-container">Done by:</div>
              <div className="content-cell-container">{props.doneBy}</div>
            </div>

            <div className="note-container-line1-block2-mobile centre-block2">
              <div className="sub-block-2">
                <EditButtonMobile handleOpen={openEditModal} />
                <DeleteButtoMobile handleOpen={openDeleteModal} />
              </div>
            </div>
          </div>
          <div
            className="note-container-line-2-mobile"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {props.noteContent}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotesContainerMobile;
